import React from 'react'
import { Props as HeadingProps } from '@components/blocks/Heading'
import { Trans } from '@lingui/react'
import FaIcon from '@mailstep/design-system/ui/Elements/Icon'
import routes from '@pages/index'

export const createWarningItems = (
  incorrectExpeditions: number | null,
  reservationsOnExpedited: number | null,
  waitingForReporter: number | null,
  waitingForResolver: number | null,
  internalStockChanges: number | null,
  isAdmin: boolean,
): HeadingProps['warningItems'] => [
  {
    icon: <FaIcon icon="expedition" />,
    title: <Trans id="heading.warning.incorrectExpeditions" message="Incorrect expeditions" />,
    link: routes.sharedExpeditionsStatus.route.toUrl({ status: 'incorrect' }),
    count: incorrectExpeditions || 0,
  },
  ...(isAdmin
    ? [
        {
          icon: <FaIcon icon="reservation" />,
          title: <Trans id="heading.warning.reservationsExpedited" message="Reservations on expedited expeditions" />,
          link: routes.sharedReservations.route.toUrl(),
          count: reservationsOnExpedited || 0,
        },
      ]
    : []),
  {
    icon: <FaIcon icon="warning" />,
    title: <Trans id="heading.warning.waitingForReporter" message="Complaints waiting for you (reporter)" />,
    link: routes.sharedComplaintsMine.route.toUrl({ status: 'waiting_for_reporter' }),
    count: waitingForReporter || 0,
  },
  {
    icon: <FaIcon icon="warning" />,
    title: <Trans id="heading.warning.waitingForResolver" message="Complaints waiting for you (resolver)" />,
    link: routes.sharedComplaintsMine.route.toUrl({ status: 'waiting_for_resolver' }),
    count: waitingForResolver || 0,
  },
  {
    icon: <FaIcon icon="transfer" />,
    title: <Trans id="heading.warning.internalStockChanges" message="Pending inventory movements" />,
    link: routes.sharedInternalStockChangesStatus.route.toUrl({ status: 'new' }),
    count: internalStockChanges || 0,
  },
]
